"use strict";

exports.__esModule = true;
exports.CheckboxCellType = exports.CELL_TYPE = void 0;
var _checkboxType = require("./checkboxType");
exports.CELL_TYPE = _checkboxType.CELL_TYPE;
exports.CheckboxCellType = _checkboxType.CheckboxCellType;


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/cellTypes/checkboxType/index.js
// module id = 1092
// module chunks = 0